// extracted by mini-css-extract-plugin
export default {"root":"UndoMapButton_root__cx9cC","button":"UndoMapButton_button__mzyzL","icon":"UndoMapButton_icon__11PBd"};